<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Fornecedores', 'link' : '/supplier' }]"
    />

    <h1 class="text-center" v-if="operation === 'store'">Novo Fornecedor</h1>
    <h1 class="text-center" v-if="operation === 'update'">Atualizar Fornecedor</h1>
    <!-- Div Formulario -->
    <form class="row" v-if="!loading" @submit.prevent="actionOperation" @keydown.enter.prevent>
      <div class="col-2"></div>
      <div class="col-12 col-md-8" >
        <div class="row">
          <div class="col-12">
            <div class="form-check text-center">
              <label class="form-label me-2">Tipo:</label>
              <input value="PF" class="btn-check" type="radio" autocomplete="off" checked v-model="suppliermodel.type" name="clientType" id="radioPF">
              <label class="btn btn-outline-primary me-2" for="radioPF">PF</label>
              <input value="PJ" class="btn-check" type="radio" autocomplete="off" v-model="suppliermodel.type" name="clientType" id="radioPJ">
              <label class="btn btn-outline-success" for="radioPJ">PJ</label>
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label v-if="suppliermodel.type == 'PF'" for="newClientName">Nome:</label>
                <label v-else for="newClientName">Nome fantasia:</label>
                <input required v-model="suppliermodel.name" name="newClientName" type="text" class="form-control" id="newClientName" placeholder="">
              </div>
            </div>
            <div v-if="suppliermodel.type == 'PJ'" class="col col-md-6">
              <div class="form-group">
                <label for="newClientLegalName">Razão social:</label>
                <input v-model="suppliermodel.name_legal" type="text" class="form-control" id="newClientLegalName" name="newClientLegalName" placeholder="">
              </div>
            </div>
          </div>
          <div v-if="suppliermodel.type == 'PF'" class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientCPF">CPF:</label>
              <input v-model="suppliermodel.cpf_cnpj" type="text" class="form-control" id="newClientCPF" name="newClientCPF" placeholder="" />
            </div>
          </div>
          <div v-if="suppliermodel.type == 'PJ'" class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientCNPJ">CNPJ:</label>
              <input v-model="suppliermodel.cpf_cnpj" type="text" class="form-control" id="newClientCNPJ" name="newClientCNPJ" placeholder="" />
            </div>
          </div>
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 mt-3">
              <div class="form-group">
                <label for="newClientEMAIL">E-mail:</label>
                <input v-model="suppliermodel.email" type="text" class="form-control" id="newClientEMAIL" name="newClientEMAIL" placeholder="">
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <div class="form-group">
                <label for="newClientWhatsapp">Whatsapp:</label>
                <input v-model="suppliermodel.phone" type="text" class="form-control" id="newClientWhatsapp" name="newClientWhatsapp" placeholder="" />
              </div>
            </div>
          </div>
          <div v-if="suppliermodel.type == 'PJ'" class="row m-0 p-0">
            <div class="col-md col-sm-12 mt-3">
              <div class="form-group">
                <label for="newClientNameRespo">Nome do Responsável:</label>
                <input v-model="suppliermodel.responsible_name" type="text" class="form-control" id="newClientNameRespo" name="newClientNameRespo" placeholder="">
              </div>
            </div>
            <div class="col-md col-sm-12 mt-3">
              <div class="form-group">
                <label for="newClientWhatsRespo">Whatsapp do Responsável:</label>
                <MaskInput mask="(##) #####-####" v-model="suppliermodel.responsible_phone" type="text" class="form-control" id="newClientWhatsRespo" name="newClientWhatsRespo" placeholder=""/>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientEndereco">Endereço:</label>
              <input v-model="suppliermodel.address" type="text" class="form-control" id="newClientEndereco" name="newClientEndereco" placeholder="">
            </div>
          </div>
          <div class="row p-0 m-0 mt-2">
            <div class="col-md col-sm-12 form-group">
              <label for="inpTxtRentalBairo">Bairo:</label>
              <input v-model="suppliermodel.neighbor" name="inpTxtRentalBairo" type="text" class="form-control" id="inpTxtRentalBairo" placeholder="">
            </div>
            <div class="col-md col-sm-12 form-group">
              <label for="inpTxtRentalNumer">Número:</label>
              <input v-model="suppliermodel.number" name="inpTxtRentalNumer" type="number" class="form-control" id="inpTxtRentalNumer" placeholder="">
            </div>
          </div>
          <div class="row m-0 p-0 mt-3">
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label for="newClientCidade">Cidade:</label>
                <input v-model="suppliermodel.city" type="text" class="form-control" id="newClientCidade" name="newClientCidade" placeholder="">
              </div>
            </div>
            <div class="col-md col-sm-12 form-group">
              <label for="inpTxtRentalState">Estado:</label>
              <select v-model="suppliermodel.state" required class="form-control" name="inpTxtRentalState" id="inpTxtRentalState">
                <!-- Default disabled option for instruction -->
                <option value="" disabled selected>Selecione o Estado</option>
                <!-- Iterate over the states list -->
                <option v-for="state in stateslist" :value="state.uf" :key="state.uf">
                  {{ state.name }}
                </option>
              </select>
            </div>
            <div class="col-md col-sm-12">
              <div class="form-group">
                <label for="newClientCEP">CEP:</label>
                <input v-model="suppliermodel.zipcode" type="text" class="form-control" id="newClientCEP" name="newClientCEP" placeholder=""/>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="newClientObs">Observação:</label>
              <textarea v-model="suppliermodel.note" type="text" class="form-control" id="newClientObs" name="newClientObs" placeholder=""></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2"></div>
      <!-- Div Botão Salvar -->
      <div class="row mt-4 text-center">
        <div class="col-12">
          <router-link class="btn btn-secondary me-2" to="/supplier">
            Voltar
          </router-link>
          <button @click="actionOperation" class="btn btn-primary me-2">
            <span>{{ operation === 'store' ? 'Salvar' : 'Atualizar' }}</span>
          </button>
          <button @click="clearForm" class="btn btn-secondary me-2">
            Limpar
          </button>
        </div>
      </div>
      <div style="height: 90px;"></div>
    </form>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3 text-center">
      <div>
        <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" v-if="operation === 'update' && loading">Carregando dados do fornecedor...</p>
        <p class="mt-2" v-else-if="loading">Salvando fornecedor...</p>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import { supplier } from '@/models/supplier';
import states from '@/services/states.js';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import router from '@/router';

export default {
  name: "NewSupplierView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const toastStore = useToastStore();
    var loading = ref(false);
    var operation = ref('store');
    const model = supplier();
    const getStates = states.get();
    const stateslist = getStates;

    const suppliermodel = reactive({
      type: 'PF',
      name : null,
      name_legal : null,
      email : null,
      cpf_cnpj : null,
      phone : null,
      responsible_phone : null,
      responsible_name : null,
      birthdate_incorporation : null,
      address : null,
      number : null,
      neighbor : null,
      city : null,
      state : null,
      zipcode : null,
      note : null
    });

    onMounted(() => {
      const query = window.location.search;
      const urlParams = new URLSearchParams(query);
      const edit = urlParams.get('edit');
      const id = urlParams.get('id');

      if (edit && id) {
        document.title = "Atualizar Fornecedor - LC3 Locações";

        operation.value = 'update';
        loading.value = true;
        model.getOne(id).then((response) => {
          suppliermodel.id = response.id;
          suppliermodel.type = response.type;
          suppliermodel.name = response.name;
          suppliermodel.name_legal = response.name_legal;
          suppliermodel.email = response.email;
          suppliermodel.cpf_cnpj = response.cpf_cnpj;
          suppliermodel.phone = response.phone;
          suppliermodel.responsible_phone = response.responsible_phone;
          suppliermodel.responsible_name = response.responsible_name;
          suppliermodel.address = response.address;
          suppliermodel.number = response.number;
          suppliermodel.neighbor = response.neighbor;
          suppliermodel.city = response.city;
          suppliermodel.state = response.state;
          suppliermodel.zipcode = response.zipcode;
          suppliermodel.note = response.note;
          loading.value = false;
        }).catch((error) => {
          toastStore.error('Erro ao carregar fornecedor: ' + parseError(error));
          loading.value = false;
        });
      }
    });

    const actionOperation = () => {
      if (operation.value === 'update') {
        update();
      } else {
        if (!suppliermodel.name) {
          toastStore.warning('O nome é obrigatório.');
          return;
        }
        store();
      }
    }

    function store() {
      loading.value = true;
      model.store(suppliermodel).then(() => {
        toastStore.success('Fornecedor cadastrado com sucesso!');
        loading.value = false;
        router.push('/supplier');
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao cadastrar fornecedor: ' + parseError(error));
      });
    }

    function update() {
      loading.value = true;
      model.update(suppliermodel).then(() => {
        toastStore.success('Fornecedor atualizado com sucesso!');
        loading.value = false;
        router.push('/supplier');
      }).catch((error) => {
        toastStore.error('Erro ao atualizar fornecedor: ' + parseError(error));
        loading.value = false;
      });
    }

    return {
      stateslist,
      suppliermodel,
      actionOperation,
      operation,
      loading
    }

  }
}
</script>